import React from "react";
import {
    ResponsiveContainer,
    FunnelChart,
    Funnel,
    Tooltip,
    LabelList,
} from "recharts";

export default function FunnelChartCard({
    title = "Population vs Enrolled vs Enrolled 30+",
    data = [],
    height = 300,
    valueKey = "value",
    labelKey = "name",
}) {
    // Argon-style colors
    const colors = ["#f5365c", "#fb6340", "#11cdef", "#5e72e4"];

    // Attach colors to data
    const coloredData = data.map((item, i) => ({
        ...item,
        fill: colors[i % colors.length],
    }));

    // Custom Argon Tooltip
    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const d = payload[0].payload;

            return (
                <div
                    style={{
                        background: "#ffffff",
                        padding: "12px 14px",
                        borderRadius: "12px",
                        border: "1px solid #e2e8f0",
                        boxShadow:
                            "0 4px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.04)",
                        minWidth: 130,
                    }}
                >
                    <div className="text-slate-700 font-semibold text-sm">
                        {d[labelKey]}
                    </div>
                    <div className="text-slate-900 font-bold text-base mt-1">
                        {d[valueKey].toLocaleString()}
                    </div>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="bg-white rounded-xl shadow-md p-4 ">
            {/* Header */}
            <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-semibold text-slate-700">{title}</h3>
                <button className="text-slate-500 hover:text-slate-700">
                    <i className="fa fa-bars text-lg"></i>
                </button>
            </div>

            {/* Legend */}
            <div className="flex flex-wrap gap-3 mb-4">
                {coloredData.map((item, i) => (
                    <div key={i} className="flex items-center gap-2">
                        <span
                            style={{
                                width: 12,
                                height: 12,
                                background: colors[i],
                                borderRadius: 4,
                                display: "inline-block",
                            }}
                        />
                        <span className="text-xs text-slate-700 font-medium">
                            {item[labelKey]}
                        </span>
                    </div>
                ))}
            </div>

            {/* Funnel Chart */}
            <div style={{ width: "100%", height }}>
                <ResponsiveContainer>
                    <FunnelChart>
                        <Tooltip content={<CustomTooltip />} />

                        <Funnel dataKey={valueKey} data={coloredData}>
                            <LabelList
                                dataKey={labelKey}
                                position="right"
                                fill="#1e293b"
                                fontSize={13}
                            />
                            <LabelList
                                dataKey={valueKey}
                                position="inside"
                                fill="#ffffff"
                                fontSize={12}
                                formatter={(v) => v.toLocaleString()}
                            />
                        </Funnel>
                    </FunnelChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
